import { useQuery } from "@tanstack/react-query";
import { getMaterialFile as geMaterialFileApi } from "@/services/apiLectureContent";

export function useMaterialFile({ courseId, lectureId, materialId }) {
  const {
    isPending,
    data: materialFile,
    error,
  } = useQuery({
    queryKey: [`material-${materialId}-File`, courseId, lectureId, materialId],
    queryFn: () =>
      geMaterialFileApi({
        courseId,
        lectureId,
        materialId,
      }),
    retry: false,
  });

  return { isPending, materialFile, error };
}
